<template>
    <div>
        <v-card flat class="score-trans" >
            <v-row dense>
                <v-col cols="12">
                    <left_panel_header ref="leftpanelheader"/>
                </v-col>
            </v-row>                
            <v-row dense>
                <v-col cols="12">
                    <left_panel_bookings ref="leftpanelbookings" :height_correction="355"/>
                </v-col>
            </v-row>                            
        </v-card>
    </div>
  </template>
  
  <script>
  
    import mxscreensize from '@/components/js/screensize';
    import left_panel_header from '@/components/dashboard/sections/left_panel_header.vue';
    import left_panel_bookings from '@/components/dashboard/sections/left_panel_bookings.vue';

    export default {
        components: {
            left_panel_header,
            left_panel_bookings,
        },            
        mixins:[mxscreensize],   
        methods: {
            load(){
                console.log('(re) loading left panel')
                this.$refs.leftpanelbookings.load();
                this.$refs.leftpanelheader.load();
            },
        },            
    }  
  </script>
  
  <style scoped>
    .score-trans {
        background: transparent !important;
    } 
  </style>